import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Stepper } from '../../../commons/Stepper';
import { SuccessForm } from '../../../loginParts/passwordRecoveryForms/components/SuccessFrom';
import { ConfirmationByEmailForm } from '../../../loginParts/passwordRecoveryForms/components/ConfirmationByEmailForm';
import { PaperAirplaneIcon } from '../../../commons/icons/PaperAirplane';
import { AddSocialsForm } from '../AddSocialsForm';
import { SavedDataIcon } from '../../../commons/icons/SavedData';

export const RegistrationUserData: FC = () => {
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const { t } = useTranslation();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSkip = () => {
    history.push('/');
  };

  const stepNames = [
    t('registration.dataEntry'),
    t('auth.confirmationEmail'),
    t('registration.addingSocialNetworks'),
    t('common.ready'),
  ];

  const recoveryMessage = (
    <p className="stepper-text">{t('registration.thisInformationWillImproveTheWorkWithYourPersonalAccount')}</p>
  );

  const stepElements = [
    <ConfirmationByEmailForm
      textElement={recoveryMessage}
      handleBack={handleSkip}
      handleCodeSubmit={handleNext}
      firstBtnLabel={t('common.skip')}
      inputPlaceholder="Email"
      handleResend={handleNext}
    />,
    <SuccessForm
      handleClick={handleNext}
      iconElement={<PaperAirplaneIcon />}
      additionalText={`${t('registration.aLetterWasSentTo')} maxsizeemail*******@gmail.com ${t(
        'registration.confirmYourE-mail',
      )}`}
      btnLabel={t('buttons.continue')}
    />,
    <AddSocialsForm handleSkip={handleSkip} handleNext={handleNext} />,
    <SuccessForm
      handleClick={handleSkip}
      additionalText={t('registration.yourDataHasBeenSaved')}
      iconElement={<SavedDataIcon />}
      btnLabel={t('registration.goToYourPersonalAccount')}
    />,
  ];

  return (
    <Stepper
      title={t('registration.userDataRegistration')}
      stepNames={stepNames}
      stepElements={stepElements}
      activeStep={activeStep}
    />
  );
};
